import { render, staticRenderFns } from "./RequestAdjacentObjectsRequests.vue?vue&type=template&id=4c37e16a&"
import script from "./RequestAdjacentObjectsRequests.vue?vue&type=script&lang=js&"
export * from "./RequestAdjacentObjectsRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QItem,QItemSection,QCheckbox,QBtn,QDialog,QItemLabel,QSelect,QTr,QTh,QTd,QTooltip,QCardActions} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QItem,QItemSection,QCheckbox,QBtn,QDialog,QItemLabel,QSelect,QTr,QTh,QTd,QTooltip,QCardActions}, component.options.components || {})
